import { DateOperator, DateParameterType, DateType } from "./Types";

export const DateFeature = {
  featureDetail: {
    name: "date",
    displayName: "Date of Birth",
    type: "date",
    multiSelect: false,
    isDefaultColumn: true
  }
};

export const DefaultFromEntry = {
  value: {
    dateOperator: DateOperator.After,
    date: {
      type: DateType.DateParameter,
      dateParameterType: DateParameterType.Today,
      fixedDate: new Date(),
    },
  },
};

export const DefaultToEntry = {
  value: {
    dateOperator: DateOperator.Before,
    date: {
      type: DateType.DateParameter,
      dateParameterType: DateParameterType.Today,
      fixedDate: new Date(),
    },
  },
};
